"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HwtStrategy = void 0;
const config_1 = __importDefault(require("../config"));
const base_student_app_1 = __importDefault(require("./util/base-student-app"));
const login_util_1 = require("./util/login-util");
const HwtStrategy = () => {
    const loginRedirect = (0, login_util_1.getLoginAppUrl)('hwt-student');
    const loginUrl = config_1.default.isDev
        ? `${loginRedirect}&redirectUrl=${window.location.href}`
        : loginRedirect;
    return (0, base_student_app_1.default)({ loginUrl });
};
exports.HwtStrategy = HwtStrategy;
